/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_De_Hosted_AltInputs */



/**
* | output |
* | --- |
* | "German flag" |
*
* @param {Model_De_Hosted_AltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_de_hosted_alt = /** @type {((inputs?: Model_De_Hosted_AltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_De_Hosted_AltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deutschlandflagge")
	return /** @type {LocalizedString} */ ("German flag")
});